export const aggregateLogUsage = (logs = []) => {
    const buckets = new Map();
    logs.forEach((log) => {
        const raw = log.created_at;
        if (!raw) return;
        const timestamp = typeof raw === 'number' && raw < 1e11 ? raw * 1000 : raw;
        const date = new Date(timestamp);
        if (Number.isNaN(date.getTime())) return;
        const key = date.toISOString().slice(0, 10);
        const bucket = buckets.get(key) || { date: key, cost: 0, tokens: 0, requests: 0 };
        bucket.cost += Number(log.cost) || 0;
        bucket.tokens += Number(log.tokens?.total ?? (Number(log.tokens?.prompt || 0) + Number(log.tokens?.completion || 0))) || 0;
        bucket.requests += Number(log.request_count) || 1;
        buckets.set(key, bucket);
    });
    return [...buckets.values()].sort((a, b) => a.date.localeCompare(b.date));
};
